import React from "react";
import { ContactProperties } from "@/utils/Api";

interface ContactCardProps {
  contact: ContactProperties;
  onClick: (contact: ContactProperties) => void;
  selected: boolean;
}

const ContactCard: React.FC<ContactCardProps> = ({ contact, onClick, selected }) => {
  const handleClick = () => {
    if (onClick) onClick(contact);
  };

  return (
    <div
      className={`flex items-center p-2 rounded-md cursor-pointer hover:border-accent-foreground ${
        selected ? "text-card-foreground border-ring border-2" : ""
      }`}
      onClick={handleClick}
    >
      <span>{contact?.displayName}</span>
      <span className="pl-2 text-muted-foreground">{contact?.org ? `- ${contact?.org}` : ""}</span>
    </div>
  );
};

export default ContactCard;
